export default "__VITE_ASSET__BGCsqp78__"